import React, { FC } from "react";
import { Button } from "antd";
import { TFunction } from "i18next";
import { CalendarViewMode } from "../types";
import { ViewModeToggle } from "./ViewModeToggle";

interface ViewModeOption {
  label: string;
  value: CalendarViewMode;
}

interface TaskCalendarHeaderProps {
  onBackClick?: () => void;
  t: TFunction;
  viewMode: CalendarViewMode;
  viewModeOptions: ViewModeOption[];
  onViewModeChange: (mode: CalendarViewMode) => void;
}

export const TaskCalendarHeader: FC<TaskCalendarHeaderProps> = ({
  onBackClick,
  t,
  viewMode,
  viewModeOptions,
  onViewModeChange,
}) => (
  <div className="px-6 pt-6 pb-4 flex items-center gap-3">
    {onBackClick && (
      <>
        <Button
          onClick={onBackClick}
          type="primary"
          className="btn-primary--dark"
        >
          {t("taskHub.schedule.goBack") || "Go back"}
        </Button>

        <h1 className="text-4xl font-bold mb-2">
          {t("taskHub.schedule.taskHubSchedule") || "Task Hub Schedule"}
        </h1>
      </>
    )}

    <ViewModeToggle
      className="ml-auto"
      viewMode={viewMode}
      options={viewModeOptions}
      onChange={onViewModeChange}
    />
  </div>
);
